<template>


  <div class="section">
     <User v-slot:user="{ user }">
      <div v-if="user">
        <div class="columns">
          <div v-if="!show" class="column">
                <h3 style="color: violet;">My Profile</h3>
              <UserProfile class="fullCard" :user="user" />
          </div>
          <div class="column">
                <h3 style="color: violet;" v-if="!show">My Articles</h3>
              <MyArticles :uid="user.uid" :show.sync="show" />
              <Publish @ublished="$emit('update:show', 0)" :uid="user.uid" :show.sync="show" />
          </div>
        </div>
        <h3 style="color: violet;" v-if="!show">All Articles</h3>

          
            <ArticleCards v-if="!show" :show.sync="show" />

      </div>
      <div v-else>
        <h3 style="color: violet;" v-if="!show">All Articles</h3>
        <ArticleCards v-if="!show" :show.sync="show" />
        <Login @newUser="getData" />
      </div>    
    </User>
  </div>
</template>

<script>
import Login from './Login'
import User from './User'
import UserProfile from './UserProfile'
import Publish from './Publish'
import MyArticles from './MyArticles'
import ArticleCards from './ArticleCards'

export default {
    components: {
        Login, 
        User,
        UserProfile,
        Publish,
        MyArticles,
        ArticleCards
    },
    data(){
      return {
        tyre: ["1", "2", "3", "4"],
        currentPage: 1,
        pageCount: 0
      }
    },
    methods: {
      getData(value){
        console.log(value);
      }
    },
    props: ['show']
}
</script>
